export default __webpack_public_path__ + "static/media/24648_Science_explore_ambience-full.9e329d48.mp3";